/* eslint-disable max-len */
import React, { FC, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { IconButton } from '@mui/material';
import boddVariables from '../../../../variables.module.scss';
import EnvironmentUtils from '../../environment-utils';

interface BoddIconComponentProps {
    clicked?: () => void;
}

const BoddIconComponent: FC<BoddIconComponentProps> = (props) => {
    const { clicked } = props;
    const ref = useRef<HTMLObjectElement>(null);
    const environment = EnvironmentUtils.GetEnvironment();

    const boddLogoPath = () => {
        switch (environment) {
            case 'Test':
                return '/bodd-logo-uat.svg';
            case 'Integration':
                return '/bodd-logo-int.svg';
            default:
                return '/bodd-logo-home.svg';
        }
    };

    const boddLogoBackground = () => {
        switch (environment) {
            case 'Test':
                return boddVariables.brandRed;
            case 'Integration':
                return boddVariables.brandYellow;
            default:
                return 'transparent';
        }
    };

    const click = () => {
        if (clicked) {
            clicked();
        }
    };

    const attachClick = (e: any) => {
        e.target.contentDocument.addEventListener('click', click);
        e.target.contentDocument.children[0].style.cursor = 'pointer';
    };

    useEffect(() => {
        const obj = ref.current;
        if (obj) {
            obj.addEventListener('load', attachClick);
        }

        return () => {
            if (obj) {
                obj.removeEventListener('load', attachClick);
            }
        };
    }, []);

    return (
        <IconButton
            component={Link}
            to="/"
            sx={{
                height: '100%',
                maxHeight: '88px',
                borderRadius: 0,
                '&.MuiButtonBase-root': {
                    backgroundColor: boddLogoBackground(),
                },
            }}
        >
        <object
            ref={ref}
            height={environment === 'Test' || environment === 'Integration' ? '90%' : '70%'}
            type="image/svg+xml"
            data={boddLogoPath()}
            data-testid="BoddIconComponent"
            aria-label="Bodd"
        />
        </IconButton>
    );
};

export default BoddIconComponent;

BoddIconComponent.defaultProps = {
    clicked: undefined,
};
